export const firebaseConfig = {
  apiKey: "AIzaSyDUV7ikhYmEbhzDBp4vvonx43KJ4vDFa1o",
  authDomain: "weathy-app-43294.firebaseapp.com",
  projectId: "weathy-app-43294",
  storageBucket: "weathy-app-43294.appspot.com",
  messagingSenderId: "321272883381",
  appId: "1:321272883381:web:295e3140e4937396dab6fc",
  measurementId: "G-RJVEG4GZGW",
};
